import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const getOuComputersData = createAsyncThunk('getOuComputers/getOuComputersData', async (value) => {
  try {
    const response = await axios.get(
      `GetADDetails/OUGroupsAndComputers?OU=${value.ouName}&Type=Computers&FQDN=${value.fqdn}`
    );
    return response.data;
  } catch (err) {
    return err;
  }
});

// Utility function to convert array to object
const arrayToObject = (data) => {
  if (!data) {
    return null;
  } else {
    const initTreeData = [];
    for (let i = 0; i < data.length; i++) {
      let obj = { title: '', key: '' };
      obj.title = data[i];
      obj.key = i + 1;
      initTreeData.push(obj);
    }
    return initTreeData;
  }
};

const initialState = {
  data: null,
  loading: false,
  error: null,
  objectData: null,
};

const getOuComputersSlice = createSlice({
  name: 'getOuComputersData',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getOuComputersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOuComputersData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.objectData = arrayToObject(action.payload);
        state.error = null;
      })
      .addCase(getOuComputersData.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});
export default getOuComputersSlice.reducer;
